import { formatDistanceToNow } from "date-fns";
import { router } from "@inertiajs/react";
import type { Comment } from "@/types/generated";

interface CommentsListProps {
  comments: Comment[];
  maxComments?: number;
  eventUrl?: string;
}

export function CommentsList({
  comments,
  maxComments = 3,
  eventUrl,
}: CommentsListProps) {
  const displayedComments = comments.slice(0, maxComments);

  if (comments.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {displayedComments.map((comment) => (
        <div key={comment.id} className="text-sm">
          <div className="flex items-baseline gap-2">
            <span className="font-semibold">
              {comment.user.first_name} {comment.user.last_name}
            </span>
            <span className="text-muted-foreground text-xs">
              {formatDistanceToNow(new Date(comment.created_at), {
                addSuffix: true,
              })}
            </span>
          </div>
          <p className="text-foreground mt-0.5">{comment.body}</p>
        </div>
      ))}
      {comments.length > maxComments && eventUrl && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            router.visit(eventUrl);
          }}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          View all {comments.length} comments
        </button>
      )}
    </div>
  );
}
